import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollGetSetupResponse } from './types';

export const payrollSetupQuery = gql`
    payrollGetSetup {
      code
      success
      message
      data {
        payrollEnabled
        payoutDate
        autoExecutePayroll
        hasFinalizedAPayroll
        nextPayrollMonthToFinalize
        payrollCycle {
          startDate
          endDate
        }
        payrollInputCycle {
          startDate
          endDate
        }
        upcomingCycles
        newJoinerArrearEnabled
        newJoinerCutoffDate
      }
    }
`;

const getPayrollSetup = gql`
  query Query {
   ${payrollSetupQuery}
  }
`;

export const payrollGetSetup = async () => {
  return graphQLApi<PayrollGetSetupResponse, {}>({
    query: getPayrollSetup,
    queryVariables: {},
  });
};
